import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api-client';
import { readBoTheme } from '@/lib/branding/applyBoTheme';
import type { Organization } from '@/pages/tenancy/types';

/**
 * Shared-cache read of the logged-in org's backoffice brand (name + logos) for
 * the chrome. Same query key as MySitePage / App so there's no extra fetch, and
 * `enabled` is left default-on — callers render only when authenticated.
 */
export function useBoBrand(): { name: string | null; logoUrl: string | null; logoDarkUrl: string | null } {
  const { data } = useQuery({
    queryKey: ['organizations', 'me'],
    queryFn: () => api.get<Organization>('/api/v1/organizations/me'),
    retry: false,
    staleTime: 60_000,
  });
  const bo = readBoTheme(data?.theme);
  return {
    name: bo?.displayName ?? null,
    logoUrl: bo?.logoUrl ?? null,
    logoDarkUrl: bo?.logoDarkUrl ?? null,
  };
}
